export const AUTH = {
  MIN_PASSWORD_CHARACTERS: 8,
  MAX_PASSWORD_CHARACTERS: 100,
};
